import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionEditDto } from "types/api";

type UseUpdateTerminalSolutionByApplicationMutationProps = {
	applicationId: string | undefined;
	redirectTo?: string;
};

const useUpdateTerminalSolutionByApplicationMutation = ({
	applicationId,
}: UseUpdateTerminalSolutionByApplicationMutationProps) => {
	const dispatch = useDispatch();
	return useMutation(
		({ id, ...data }: TerminalSolutionEditDto) => {
			return applicationTerminalService.updateTerminalSolution(
				id,
				data,
				applicationId,
			);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateTerminalSolutionByApplicationMutation;
